import { render } from "./WarehouseDatatableFormTitle.vue?vue&type=template&id=b9cc1e8e"
import script from "./WarehouseDatatableFormTitle.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableFormTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__